




import { Component, Prop, Vue } from 'vue-property-decorator';
import CmsBlock from '@/components/Cms/Block.vue';
import device from '@/store/modules/device';

@Component({
    components: {
        CmsBlock,
    },
})
export default class AppBanner extends Vue {
    @Prop() public bannerCmsBlockName!: string;

    get appBannerVisible() {
        return device.isApp;
    }
}
